<template>
    <missing-info v-bind="cardProps" :icon="icons.link" card large :color="model.color ?? 'primary'" :xs-tile="mobileTile" :sm-tile="mobileTile" min-height="100">
        <div class="flex justify-between items-center flex-column sm:flex-row">
            <p class="mb-0 leading-normal">{{ model.model_name === 'club' ? $t('text.club.is_not_managed', {club: club.display_name}) : $t('text.event.is_not_managed', {club: club?.display_name ?? model.display_name}) }}</p>

            <wrapper v-if="club" break-column="xs">
                <btn @click.prevent="showRequestManagementModal = true">
                    {{ $t('action.club.request_management') }}
                </btn>
            </wrapper>
        </div>

        <client-only>
			<lazy-ajax-form-modal v-if="club" v-model="showRequestManagementModal"
								  :submit-text="$t('action.request')"
								  :form-options="{action: $api('clubs.request_management', club.id), data: data, method: 'POST'}"
								  :modal-options="{title: $t('action.manage_name_on_spoferan', {name: club.display_name})}">

				<template v-if="model.model_name === 'club'">
					<p>{{ $t('text.club.request_management', {club: model.display_name}) }}</p>
					<wrapper grow>
						<btn :to="`${$config.public.aboutUrl}/clubmanager`" target="_blank">
							{{ $t('action.more_information') }}
						</btn>
					</wrapper>
				</template>
				<template v-else>
					<p>{{ $t('text.event.request_management', {club: club.display_name, event: model.display_name}) }}</p>
					<wrapper grow>
						<btn :to="`${$config.public.aboutUrl}/resultastic`" target="_blank">
							{{ $t('action.more_information') }}
						</btn>
					</wrapper>
				</template>

				<divider class="mt-16"/>

				<template v-if="!$auth.loggedIn">
					<p class="subheading">{{ $t('action.create_free_account') }}</p>
					<p class="subheading-description">
						<span>{{ $t('text.club.create_free_account', {club: club.display_name}) }}</span>
						<nuxt-link :to="{path: 'login', query: {redirect: $route.fullPath}}" rel="nofollow">{{ $t('action.login') }}</nuxt-link>
					</p>
					<account-registration-form-inputs :data="data.account" name-prefix="account."/>
					<divider class="mt-16"/>
				</template>

				<lazy-form-textarea name="text" v-model="data.text"
									:rules="{required: true, min: 10, max: 500}"
									:rows="4"
									:label="$t('label.explanation')"
									:help="$t('help.club.request_management.text', {club: club.display_name})"
									:placeholder="$t('help.club.request_management.text', {club: club.display_name})"></lazy-form-textarea>

			</lazy-ajax-form-modal>
		</client-only>
    </missing-info>
</template>

<script>
import {mdiShieldLinkVariant} from '@mdi/js';
import {CardMixin} from "@spoferan/nuxt-spoferan/mixins";

export default {
    name: 'RequestManagementCard',

	mixins: [CardMixin],

    props: {

        // An event or club
        model: {
            type: Object,
            required: true
        },

		mobileTile: {
			type: Boolean,
			default: false
		}
    },

    data() {
        return {
            data: {
                account: {}
            },
            showRequestManagementModal: false,
            icons: {
                link: mdiShieldLinkVariant,
            }
        }
    },

    computed: {
        club() {
            return this.model.model_name === 'club' ? this.model : this.model.club;
        }
    }
}
</script>